/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { FiltersState } from '../../FiltersContext';

export function convertLocationFilters({
    params,
    filters,
}: {
    params: URLSearchParams;
    filters: FiltersState;
}): void {
    if (filters.location) {
        params.set('location', filters.location);
    }

    if (filters.latSw && filters.lngSw && filters.latNe && filters.lngNe) {
        params.set('lat_sw', filters.latSw.toString());
        params.set('lng_sw', filters.lngSw.toString());
        params.set('lat_ne', filters.latNe.toString());
        params.set('lng_ne', filters.lngNe.toString());
    }
    // TODO: This probably should be else if, but there is some logic that allows a
    // bounding box with sort type of distance, which requires lat, lng. Problem is,
    // this is kinda meaningless
    if (filters.lat && filters.lng) {
        params.set('lat', filters.lat.toString());
        params.set('lng', filters.lng.toString());
    }
}
